
export enum SourceType
{
    CONNECTION="CONNECTION",
    PLATFORM  = "PLATFORM",
    REPORT ="REPORT",
    CUSTOM_CONNECTION  = "CUSTOM_CONNECTION",
    EXTRACTOR="EXTRACTOR"

}